import React from 'react'
import { Table, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import moment from 'moment'
import { getNormalizedPrice } from 'shared/utils/getNormalizedPrice'
import { IOrderLedgerRow } from 'shared/utils/transactions/getOrderLedger'
import styles from './OrderLedgerTable.module.scss'

interface IOrderLedgerTableProps {
  rows: IOrderLedgerRow[]
  isLoading: boolean
  // Лента супер-заказа собрана из нескольких заказов — строке нужен номер своего
  withOrderNumber?: boolean
}

export const OrderLedgerTable: React.FC<IOrderLedgerTableProps> = ({
  rows,
  isLoading,
  withOrderNumber = false
}) => {
  const columns: ColumnsType<IOrderLedgerRow> = React.useMemo(
    () => [
      {
        title: 'Тип транзакции',
        dataIndex: 'title',
        width: withOrderNumber ? '20%' : '22%',
        render: (_, { title }) => {
          return <Typography.Text>{title}</Typography.Text>
        }
      },
      ...(withOrderNumber
        ? [
          {
            title: 'Заказ',
            dataIndex: 'orderNumber',
            width: '9%',
            render: (_: unknown, { orderNumber }: IOrderLedgerRow) => {
              return (
                <Typography.Text className={styles.nowrap}>
                  {orderNumber ? `№ ${orderNumber}` : '—'}
                </Typography.Text>
              )
            }
          }
        ]
        : []),
      {
        title: 'Сумма',
        dataIndex: 'sum',
        width: '13%',
        render: (_, { sum }) => {
          return (
            <Typography.Text className={styles.nowrap}>
              {getNormalizedPrice(Math.abs(sum))}
            </Typography.Text>
          )
        }
      },
      {
        title: 'Комментарий',
        dataIndex: 'comment',
        width: withOrderNumber ? '23%' : '24%',
        render: (_, { comment }) => {
          return <Typography.Text>{comment}</Typography.Text>
        }
      },
      {
        title: 'Дата',
        dataIndex: 'date',
        width: withOrderNumber ? '16%' : '19%',
        render: (_, { createdAt }) => {
          return (
            <Typography.Text className={styles.nowrap}>
              {moment(createdAt).format('DD.MM.YYYY HH:mm')}
            </Typography.Text>
          )
        }
      },
      {
        title: 'Юмани ID',
        dataIndex: 'yooMoneyId',
        width: withOrderNumber ? '19%' : '22%',
        render: (_, { payment_id }) => {
          if (!payment_id) {
            return null
          }
          return (
            <Typography.Link
              href={`https://yookassa.ru/my/payments?search=${payment_id}`}
              target='_blank'
            >
              {payment_id}
            </Typography.Link>
          )
        }
      }
    ],
    [withOrderNumber]
  )

  return (
    <Table
      scroll={{
        x: 800
      }}
      columns={columns}
      dataSource={rows}
      loading={isLoading}
      rowKey={(el) => el.key}
      pagination={false}
    />
  )
}
